export enum AuthDialogMode {
  AUTH_LIST,
  QUESTION,
  MODIFY,
}
